import { render, staticRenderFns } from "./CustomInputUploadImage.vue?vue&type=template&id=62d55894&scoped=true"
import script from "./CustomInputUploadImage.vue?vue&type=script&lang=js"
export * from "./CustomInputUploadImage.vue?vue&type=script&lang=js"
import style0 from "./CustomInputUploadImage.vue?vue&type=style&index=0&id=62d55894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d55894",
  null
  
)

export default component.exports